// Used to control how certain parts of the AboutMe component renders
export enum AboutMeMode {
  DEFAULT = 'default',
  CARD = 'card',
}
